import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { AccountService } from '../service/account.service';

// Chiamata HTTP al server — usata all'ingresso nell'app (canActivate)
export const authGuard: CanActivateFn = () => {
    const account = inject(AccountService);
    const router = inject(Router);

    return account.identity(true).pipe(
        map(() => true),
        catchError(() => {
            router.navigate(['/auth/login']);
            return of(false);
        })
    );
};

// Per navigazioni interne: usa la cache se verificata negli ultimi 30s, altrimenti chiede al server
export const authGuardChild: CanActivateChildFn = () => {
    const account = inject(AccountService);
    const router = inject(Router);

    if (account.isAuthCheckFresh()) {
        return true;
    }

    return account.identity(true).pipe(
        map(() => true),
        catchError(() => {
            router.navigate(['/auth/login']);
            return of(false);
        })
    );
};
